import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const brandService = {
    getBrandsPagination,
    storeBrand,
    getBrand,
    editBrand,
    deleteBrand,
    updateBrandStatus,

    getFaqsPagination,
    getFaqsCategories,
    storeFaq,
    getFaq,
    editFaq,
    deleteFaq,
    updateFaqStatus,


    getTransmittalTemplatesPagination,
    storeTransmittalTemplate,
    getTransmittalTemplate,
    editTransmittalTemplate,
    deleteTransmittalTemplate,
    getTransmittalTemplatesCategories,
    getTransmittalTemplatesTypes,
    updateTransmittalTemplateStatus,

    getBrandAppSetting,
    updateBrandAppSettings,
    handleBrandActiveStatus
}

function getBrandsPagination(page, filter, sort, pageSize, status) {
    return SC.getCall('brands', { page, filter, sort, pageSize, status });
}
function storeBrand(brandData) {
    return SC.postCall('brands', brandData);
}
function getBrand(brandId) {
    return SC.getCall(`brands/${pathSegment(brandId)}`);
}
function editBrand(brandData, brandId) {
    return SC.postCall(`brands/${pathSegment(brandId)}`, brandData);
}
function deleteBrand(brandId) {
    return SC.deleteCall(`brands/${pathSegment(brandId)}`);
}
function updateBrandStatus(brandId, brandData) {
    return SC.putCall(`brandStatusChange/${pathSegment(brandId)}`, brandData);
}
function getFaqsPagination(accountId, page, filter, sort, pageSize, is_web) {
    return SC.getCall(`brands/${pathSegment(accountId)}/faqs`, { page, filter, sort, pageSize, is_web });
}
function getFaqsCategories() {
    return SC.getCall('faqs/categories');
}
function storeFaq(accountId, faqData) {
    return SC.postCall(`brands/${pathSegment(accountId)}/faqs`, faqData);
}
function getFaq(accountId, faqId) {
    return SC.getCall(`brands/${pathSegment(accountId)}/faqs/${pathSegment(faqId)}`);
}
function editFaq(accountId, faqData, faqId) {
    return SC.putCall(`brands/${pathSegment(accountId)}/faqs/${pathSegment(faqId)}`, faqData);
}
function deleteFaq(accountId, faqId) {
    return SC.deleteCall(`brands/${pathSegment(accountId)}/faqs/${pathSegment(faqId)}`);
}
function updateFaqStatus(faqId, faqData) {
    return SC.putCall(`faqStatusChange/${pathSegment(faqId)}`, faqData);
}
function getTransmittalTemplatesPagination(accountId, page, filter, sort, pageSize, status) {
    return SC.getCall(`brands/${pathSegment(accountId)}/transmittalTemplate`, { page, filter, sort, pageSize, status });
}
function storeTransmittalTemplate(accountId, transmittalTemplateData) {
    return SC.postCall(`brands/${pathSegment(accountId)}/transmittalTemplate`, transmittalTemplateData);
}
function getTransmittalTemplate(accountId, transmittalTemplateId) {
    return SC.getCall(`brands/${pathSegment(accountId)}/transmittalTemplate/${pathSegment(transmittalTemplateId)}`);
}
function editTransmittalTemplate(accountId, transmittalTemplateData, transmittalTemplateId) {
    return SC.putCall(`brands/${pathSegment(accountId)}/transmittalTemplate/${pathSegment(transmittalTemplateId)}`, transmittalTemplateData);
}
function deleteTransmittalTemplate(accountId, transmittalTemplateId) {
    return SC.deleteCall(`brands/${pathSegment(accountId)}/transmittalTemplate/${pathSegment(transmittalTemplateId)}`);
}
function getTransmittalTemplatesTypes() {
    return SC.getCall('transmittalTemplate/types');
}
function getTransmittalTemplatesCategories(typeId) {
    console.log('typeId 2', typeId);
    return SC.getCall(`transmittalTemplate/categories/${pathSegment(typeId)}`);
}
function updateTransmittalTemplateStatus(transmittalTemplateId, transmittalTemplateData) {
    return SC.putCall(`transmittalTemplateStatusChange/${pathSegment(transmittalTemplateId)}`, transmittalTemplateData);
}
function getBrandAppSetting(brandId) {
    return SC.getCall(`getBrandAppSettingFields/${pathSegment(brandId)}`);
}
function updateBrandAppSettings(id, data) {
    return SC.putCall(`updateBrandAppSettings/${pathSegment(id)}`, data);
}

function handleBrandActiveStatus(id) {
    return SC.putCall(`handleBrandActiveStatus/${pathSegment(id)}`, {});
}
